import { Button, TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { useInfiniteTable } from 'hooks/useInfiniteTable';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { useCustomParamId } from 'hooks/useParamId';
import { t } from 'i18next';
import { PiNavigationArrow } from 'react-icons/pi';
import { useGetArtistProductsInfinite } from 'services/artists/products';
import { PRODUCT_TYPE } from 'services/contract/types';

const ArtistProductsTab = () => {
  const artistId = useCustomParamId('id');

  const products = useGetArtistProductsInfinite(artistId);

  const tableProps = useInfiniteTable(products);

  const navigateToNewWindow = useNewWindowNavigate();

  return (
    <Table
      id='artist-products2'
      //   size='compact'
      {...tableProps}
      select={undefined}
      data={{
        nodes: tableProps.data.nodes.map(p => ({
          ...p,
          id:
            p.productType.id === PRODUCT_TYPE.Digital
              ? `/music-product-digital/${p.id}/tracks`
              : p.productType.id === PRODUCT_TYPE.Physical
              ? `/music-product-physical/${p.id}/tracks`
              : p.productType.id === PRODUCT_TYPE.YouTube
              ? `/channel/${p.id}/tracks`
              : p.productType.id === PRODUCT_TYPE.Merch
              ? `/merch/${p.id}/tracks`
              : p.id,
        })),
      }}
      columns={[
        {
          label: t('input.label.type'),
          renderCell: ({ productType }) => (
            <TableItem>
              <TableItem.Text
                text={t(`enum.PRODUCT_TYPE.${PRODUCT_TYPE[productType.id]}`)}
              />
            </TableItem>
          ),
        },
        {
          label: t('input.label.title'),
          renderCell: ({ title }) => (
            <TableItem>
              <TableItem.Text text={title} />
            </TableItem>
          ),
        },
        {
          label: t('input.label.ean'),
          renderCell: ({ ean }) => (
            <TableItem>
              <TableItem.Text text={ean} />
            </TableItem>
          ),
        },
        {
          label: '',
          renderCell: (product) => (
            <TableItem justifyPosition='end'>
              <Button
                isClear
                onlyIcon
                onClick={() => navigateToNewWindow(product.id.substring(1))}>
                <Button.Icon
                  icon={<PiNavigationArrow transform='scale(-1,1)' />}
                />
              </Button>
            </TableItem>
          ),
        },
      ]}
    />
  );
};

export default ArtistProductsTab;
